"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var LightBulb_exports = {};
__export(LightBulb_exports, {
  default: () => LightBulb_default
});
module.exports = __toCommonJS(LightBulb_exports);
var React = __toESM(require("react"));
var import_styled_components = __toESM(require("styled-components"));
const SvgIcon = ({
  title,
  titleId,
  desc,
  descId,
  iconSize,
  ariaHidden,
  ...props
}) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    ...props,
    viewBox: "0 0 21 20",
    fill: "currentColor",
    color: "currentColor",
    role: "img",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  },
  desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null,
  title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null,
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M10.4609 3.82422C9.91406 3.82422 9.39974 3.92839 8.91797 4.13672C8.4362 4.34505 8.01302 4.63151 7.64844 4.99609C7.29688 5.34766 7.01693 5.76432 6.80859 6.24609C6.60026 6.72786 6.49609 7.24219 6.49609 7.78906C6.49609 8.4401 6.63932 9.03906 6.92578 9.58594C7.21224 10.1328 7.59635 10.5885 8.07812 10.9531C8.26042 11.0964 8.41016 11.2721 8.52734 11.4805C8.65755 11.6888 8.72266 11.9297 8.72266 12.2031V13.082H12.1797V12.2031C12.1797 11.9297 12.2448 11.6888 12.375 11.4805C12.5052 11.2721 12.6615 11.0964 12.8438 10.9531C13.3255 10.5885 13.7096 10.1328 13.9961 9.58594C14.2826 9.03906 14.4258 8.4401 14.4258 7.78906C14.4258 7.24219 14.3216 6.72786 14.1133 6.24609C13.9049 5.76432 13.6185 5.34766 13.2539 4.99609C12.9023 4.63151 12.4857 4.34505 12.0039 4.13672C11.5221 3.92839 11.0078 3.82422 10.4609 3.82422ZM5.5 7.78906C5.5 7.11198 5.63021 6.46745 5.89062 5.85547C6.15104 5.25651 6.5026 4.73568 6.94531 4.29297C7.40104 3.83724 7.92839 3.47917 8.52734 3.21875C9.1263 2.95833 9.77083 2.82812 10.4609 2.82812C11.138 2.82812 11.7826 2.95833 12.3945 3.21875C12.9935 3.47917 13.5143 3.83724 13.957 4.29297C14.4128 4.73568 14.7708 5.25651 15.0312 5.85547C15.2917 6.46745 15.4219 7.11198 15.4219 7.78906C15.4219 8.59635 15.2396 9.34505 14.875 10.0352C14.5234 10.7253 14.0417 11.2982 13.4297 11.7539C13.3516 11.819 13.293 11.8906 13.2539 11.9688C13.2148 12.0469 13.1953 12.125 13.1953 12.2031V13.4336C13.1953 13.6159 13.1302 13.7721 13 13.9023C12.8698 14.0195 12.7135 14.0781 12.5312 14.0781H8.39062C8.20833 14.0781 8.05208 14.0195 7.92188 13.9023C7.79167 13.7721 7.72656 13.6159 7.72656 13.4336V12.2031C7.72656 12.125 7.70703 12.0469 7.66797 11.9688C7.62891 11.8906 7.5638 11.819 7.47266 11.7539C6.8737 11.2982 6.39193 10.7253 6.02734 10.0352C5.67578 9.34505 5.5 8.59635 5.5 7.78906ZM8.25391 15.4062C8.25391 15.276 8.29948 15.1654 8.39062 15.0742C8.49479 14.9701 8.61198 14.918 8.74219 14.918H12.1602C12.3034 14.918 12.4206 14.9701 12.5117 15.0742C12.6159 15.1654 12.668 15.276 12.668 15.4062C12.668 15.5495 12.6159 15.6732 12.5117 15.7773C12.4206 15.8685 12.3034 15.9141 12.1602 15.9141H8.74219C8.61198 15.9141 8.49479 15.8685 8.39062 15.7773C8.29948 15.6732 8.25391 15.5495 8.25391 15.4062ZM8.68359 17.2422C8.68359 17.099 8.72917 16.9818 8.82031 16.8906C8.92448 16.7865 9.04167 16.7344 9.17188 16.7344H11.7305C11.8737 16.7344 11.9909 16.7865 12.082 16.8906C12.1862 16.9818 12.2383 17.099 12.2383 17.2422C12.2383 17.3724 12.1862 17.4896 12.082 17.5938C11.9909 17.6849 11.8737 17.7305 11.7305 17.7305H9.17188C9.04167 17.7305 8.92448 17.6849 8.82031 17.5938C8.72917 17.4896 8.68359 17.3724 8.68359 17.2422Z",
      fill: "currentColor"
    }
  )
);
const SvgLightBulb = (0, import_styled_components.default)(SvgIcon)(({ iconSize, color }) => {
  const getIconSize = () => {
    const standardIconSize = {
      s: "17px",
      // 17px small
      m: "20px",
      // 20px medium
      l: "24px",
      // 24px large
      xl: "32px",
      // 32px extraLarge
      inherit: "inherit"
      // inherits size from parent
    };
    return standardIconSize[iconSize];
  };
  return import_styled_components.css`
    width: ${getIconSize()};
    height: ${getIconSize()};
    display: inline-block;
    color: ${color};
  `;
});
var LightBulb_default = SvgLightBulb;
